import { useSelector, useDispatch } from "react-redux";
import {
  increaseQty,
  decreaseQty,
  removeFromCart,
  clearCart
} from "../features/cart/cartSlice";

function Cart() {
  const dispatch = useDispatch();
  const cartItems = useSelector((state) => state.cart.cartItems);

  // 💰 total price
  const total = cartItems.reduce(
    (acc, item) => acc + item.caloriesPerServing * item.quantity,
    0
  );

  if (cartItems.length === 0) return <h2>Your cart is empty</h2>;

  return (
    <div className="container mt-4">
      
      <h2>Your Cart</h2>

      {cartItems.map((item) => (
        <div key={item.id} className="border p-3 mb-3">
          <h5>{item.name}</h5>
          <p>₹ {item.caloriesPerServing}</p>

          {/* Quantity Controls */}
          <div className="d-flex align-items-center gap-2">
            <button onClick={() => dispatch(decreaseQty(item.id))}>-</button>
            <span>{item.quantity}</span>
            <button onClick={() => dispatch(increaseQty(item.id))}>+</button>
          </div>

          <p>Subtotal: ₹ {item.caloriesPerServing * item.quantity}</p>

          <button
            className="btn btn-danger btn-sm"
            onClick={() => dispatch(removeFromCart(item.id))}
          >
            Remove
          </button>
        </div>
      ))}

      <h4>Total: ₹ {total}</h4>

      <button
        className="btn btn-dark"
        onClick={() => dispatch(clearCart())}
      >
        Clear Cart
      </button>


      
    </div>
  );
}

export default Cart;